import { DateTimes } from "@salaxy/core";
import { InputBase } from "./_InputBase";

/**
 * Controller behind form controls that select time
 */
export class InputTimeController extends InputBase<string | number> {
    /** Type of the input element. Options are minutes and isoTime */
    public type: "minutes" | "time" = "time";

    public _viewValue: Date;
    public debug: any;

    /** Sets the default values in init. */
    public $onInit() {
      super.$onInit();
    }

    /**
     * Gets or sets the string value that is used in the view.
     */
    public get viewValue(): Date {
      if (this.value) {
        if (this.type === "time") {
          if (this._viewValue?.getTime() !== DateTimes.fromTime(this.value as string).getTime()) {
            this._viewValue = DateTimes.fromTime(this.value as string);
          }
        }

        else if (this.type === "minutes") {
          if (this._viewValue?.getTime() !== DateTimes.fromMinutes(this.value as number).getTime()) {
            this._viewValue = DateTimes.fromMinutes(this.value as number);
          }
        }

        return this._viewValue;
      }
      return null;
    }
    public set viewValue(value: Date) {
      if (this.type === "time") {
        this.value = DateTimes.asTime(value);
      }

      else if (this.type === "minutes") {
        this.value = DateTimes.asMinutes(value);
      }

      this.onChange();
    }
}
